<template>
    Acreditación finalizada con éxito
  </template>
  
